import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, message, Input, Popconfirm, Card } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { eventCategoryService } from '../../services';

const EventCategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form, setForm] = useState({
    tensukien: '',
    noidung: '',
    ghichu: ''
  });

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await eventCategoryService.getAll();
      if (response && Array.isArray(response)) {
        setCategories(response);
      }
    } catch (error) {
      message.error('Lỗi khi tải danh sách phân loại sự kiện');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingCategory(null);
    setForm({ tensukien: '', noidung: '', ghichu: '' });
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingCategory(record);
    setForm({
      tensukien: record.TenSuKien || '',
      noidung: record.NoiDung || '',
      ghichu: record.GhiChu || ''
    });
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await eventCategoryService.delete(id);
      message.success('Xóa phân loại sự kiện thành công');
      fetchCategories();
    } catch (error) {
      message.error('Lỗi khi xóa phân loại sự kiện');
    }
  };

  const handleSubmit = async () => {
    if (!form.tensukien.trim()) {
      message.error('Vui lòng nhập tên sự kiện');
      return;
    }

    try {
      if (editingCategory) {
        await eventCategoryService.update(editingCategory.id, form);
        message.success('Cập nhật phân loại sự kiện thành công');
      } else {
        await eventCategoryService.create(form);
        message.success('Thêm phân loại sự kiện thành công');
      }
      setModalVisible(false);
      fetchCategories();
    } catch (error) {
      message.error(editingCategory ? 'Lỗi khi cập nhật' : 'Lỗi khi thêm mới');
    }
  };

  const filteredCategories = categories.filter(category =>
    category.TenSuKien?.toLowerCase().includes(searchText.toLowerCase()) ||
    category.NoiDung?.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Tên Sự Kiện',
      dataIndex: 'TenSuKien',
      key: 'TenSuKien',
    },
    {
      title: 'Nội Dung',
      dataIndex: 'NoiDung',
      key: 'NoiDung',
    },
    {
      title: 'Ghi Chú',
      dataIndex: 'GhiChu',
      key: 'GhiChu',
    },
    {
      title: 'Thao tác',
      key: 'action',
      width: 150,
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Sửa
          </Button>
          <Popconfirm
            title="Bạn có chắc chắn muốn xóa?"
            onConfirm={() => handleDelete(record.id)}
            okText="Có"
            cancelText="Không"
          >
            <Button
              type="primary"
              danger
              size="small"
              icon={<DeleteOutlined />}
            >
              Xóa
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card title="Quản lý Phân Loại Sự Kiện">
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Input
            placeholder="Tìm kiếm theo tên sự kiện hoặc nội dung..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 300 }}
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAdd}
          >
            Thêm Phân Loại
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={filteredCategories}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `Tổng ${total} mục`,
          }}
        />

        <Modal
          title={editingCategory ? 'Sửa Phân Loại Sự Kiện' : 'Thêm Phân Loại Sự Kiện'}
          open={modalVisible}
          onOk={handleSubmit}
          onCancel={() => setModalVisible(false)}
          okText={editingCategory ? 'Cập nhật' : 'Thêm'}
          cancelText="Hủy"
        >
          <div style={{ marginBottom: 16 }}>
            <label>Tên Sự Kiện *</label>
            <Input
              value={form.tensukien}
              onChange={(e) => setForm({ ...form, tensukien: e.target.value })}
              placeholder="Nhập tên sự kiện"
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label>Nội Dung</label>
            <Input.TextArea
              value={form.noidung}
              onChange={(e) => setForm({ ...form, noidung: e.target.value })}
              placeholder="Nhập nội dung sự kiện"
              rows={3}
            />
          </div>
          <div>
            <label>Ghi Chú</label>
            <Input.TextArea
              value={form.ghichu}
              onChange={(e) => setForm({ ...form, ghichu: e.target.value })}
              placeholder="Nhập ghi chú"
              rows={2}
            />
          </div>
        </Modal>
      </Card>
    </div>
  );
};

export default EventCategoryList;